import apis from "@/api";
import utils from "@/utils";
import actions from "@/store/actions";

export const addVideoMetaData = (data) => {
  return async (dispatch) => {
    dispatch(actions.videoMetaDataActions.addMetaData(data));
  };
};

export const addCurrVideo = (data) => {
  return async (dispatch) => {
    dispatch(actions.videoMetaDataActions.addCurrVideo(data));
  };
};

export const resetVideoMetaData = () => {
  return async (dispatch) => {
    dispatch(actions.videoMetaDataActions.resetMetaData());
  };
};

export const updateVideoMetaData = (data) => {
  return async (dispatch) => {
    dispatch(actions.videoMetaDataActions.updateMetaData(data));
  };
};

export const addBulkVideoMetaData = (data) => {
  return async (dispatch) => {
    dispatch(actions.videoMetaDataActions.addBulkMetaData(data));
  };
};

export const fetchVideoMetaData = (user) => {
  return async (dispatch) => {
    if (utils.getCookie("login_state") || user?.email) {
      const res = await apis.getUserWatchHistory(user?._id);

      if (res.status === 200) {
        if (res.data.result.history && res.data.result.history) {
          const resp = res?.data?.result?.history?.map((item) => {
            return {
              id:
                item.courseId && item.videoId
                  ? `${item.courseId}_${item.videoId}`
                  : item.videoId,
              initiate: Date.now(),
              lastplaystatus: item.lastPlayStatus,
              currsecs: item.currSecs,
              status: false,
              views: false,
            };
          });
          dispatch(actions.videoMetaDataActions.addBulkMetaData(resp));
          return;
        }
      }
    }
    dispatch(actions.historyActions.fetchwatchhistory([]));
  };
};
